<template>
  <div>
    <base-label id="qdrant-model" label="Embedding model" :is-admin="true"/>
    <base-select id="qdrant-model"
                 :value="embeddingModel"
                 :options="embeddingModels"
                 class="w-full h-10 mt-1"
                 @input="embeddingModel = $event"
    />
  </div>
</template>

<script>
import indexesService from '@/services/amio/indexes.service'
import {
  createDefaultProviderForm,
  DEFAULT_EMBEDDING_MODEL
} from '@/utils/index-provider.utils'

// The target collection is not chosen here. The indexer resolves it per source type
// (url -> products, file/web -> documents), with an optional per-org override.
export default {
  name: 'SettingsIndexProvider',
  props: {
    value: {
      type: Object,
      default: createDefaultProviderForm
    }
  },
  data() {
    const params = this.value.provider_params || {}
    return {
      embeddingModel: params.embeddingModel || DEFAULT_EMBEDDING_MODEL,
      embeddingModels: [DEFAULT_EMBEDDING_MODEL]
    }
  },
  async created() {
    try {
      const models = await indexesService.getEmbeddingModels()
      if (models && models.length) this.embeddingModels = models
    } catch (err) {
      // keep the default fallback list if the engine is unreachable
    }
  },
  computed: {
    config() {
      return createDefaultProviderForm({ embeddingModel: this.embeddingModel })
    }
  },
  watch: {
    config: {
      deep: true,
      handler(config) {
        this.$emit('input', config)
      }
    }
  }
}
</script>
